<div class="result-field-multi-filter">
  @for (filter of filters; track filter.id; let i = $index) {
    <div class="filter-row d-flex gap-2 align-items-center" [class.mt-2]="i > 0">
      <p-select
        [id]="'result-field-select-' + filter.id"
        [options]="fields"
        optionValue="key"
        optionLabel="label"
        [(ngModel)]="filter.field"
        (onChange)="onFieldChange(filter)"
        [showClear]="true"
        [filter]="fields.length > 5"
        filterBy="label"
        [placeholder]="fieldPlaceholder | translate"
        style="min-width: 140px;"
      >
      </p-select>
      <input
        type="text"
        [id]="'result-field-value-' + filter.id"
        pInputText
        [(ngModel)]="filter.value"
        (input)="onValueChange(filter)"
        [disabled]="!filter.field"
        [placeholder]="valuePlaceholder | translate"
        style="width: 150px;"
      />
      @if (filter.field && filter.value) {
        <button
          type="button"
          class="btn btn-link p-0 text-secondary"
          (click)="clearFilter(filter)"
          [title]="'filter.result-field.clear-filter' | translate"
          style="line-height: 1;"
        >
          <span class="material-symbols-outlined" style="font-size: 20px;">close</span>
        </button>
      }
      @if (filters.length > 1) {
        <button
          type="button"
          class="btn btn-link p-0 text-danger"
          (click)="removeFilter(filter.id)"
          [title]="'filter.result-field.remove-filter' | translate"
          style="line-height: 1;"
        >
          <span class="material-symbols-outlined" style="font-size: 20px;">delete</span>
        </button>
      }
      @if (i === 0) {
        <button
          type="button"
          class="btn btn-outline-secondary btn-sm"
          (click)="addFilter()"
          [title]="'filter.result-field.add-filter' | translate"
          style="line-height: 1; padding: 0.25rem 0.4rem;"
        >
          <span class="material-symbols-outlined" style="font-size: 18px;">add</span>
        </button>
      }
    </div>
  }
</div>
